import { RiPencilLine } from '@remixicon/react';

import {
  type ToolGroupEntry,
  createToolExtension,
} from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';
import { DrawingCanvas, type DrawingElement } from './DrawingCanvas';

const MAX_DRAWING_DIMENSION = 4096;

type DrawToolInput = {
  width: number;
  height: number;
  elements: DrawingElement[];
  backgroundColor?: string;
};

const isValidDimension = (value: unknown): value is number => {
  return (
    typeof value === 'number' &&
    Number.isFinite(value) &&
    value > 0 &&
    value <= MAX_DRAWING_DIMENSION
  );
};

const isDrawToolInput = (input: unknown): input is DrawToolInput => {
  if (!input || typeof input !== 'object') {
    return false;
  }

  const drawToolInput = input as Partial<DrawToolInput>;
  return (
    isValidDimension(drawToolInput.width) &&
    isValidDimension(drawToolInput.height) &&
    Array.isArray(drawToolInput.elements) &&
    drawToolInput.elements.length > 0
  );
};

export const DrawToolRenderer = ({ entry }: { entry: ToolGroupEntry }) => {
  const input = entry.input;
  if (!isDrawToolInput(input)) return null;
  return (
    <DrawingCanvas
      width={input.width}
      height={input.height}
      elements={input.elements}
      backgroundColor={input.backgroundColor}
    />
  );
};

export const DrawToolExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'draw',
    predicate: tool => tool === 'mcp__confidence__draw',
    icon: RiPencilLine,
    display: 'prominent',
    render: () => null,
    renderTool: entry => <DrawToolRenderer entry={entry} />,
  }),
);
